module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-cove-fluted-hayman-1.38134c3f.jpg";